import { actionTypes, urls } from '../../constants';

export const setQueryParams = params => ({
  type: actionTypes.SET_QUERY_PARAMS,
  params,
  isLoading: true,
});

export const fetchConfig = () => {
  return async dispatch => {
    try {
      const response = await fetch(urls.ENV_CONFIG);
      const contentData = await response.json();
      dispatch({
        type: actionTypes.FETCH_CONFIG_SUCCESS,
        data: contentData,
        isLoading: false,
      });
    } catch {
      dispatch(fetchFailed());
    }
  };
};

export const fetchContent = () => {
  return async dispatch => {
    try {
      const response = await fetch(urls.CONTENT_URL);
      const contentData = await response.json();
      dispatch({
        type: actionTypes.FETCH_CONTENT_SUCCESS,
        data: contentData,
        isLoading: false,
      });
    } catch {
      dispatch(fetchFailed());
    }
  };
};

const fetchFailed = () => ({
  type: actionTypes.FETCH_FAILED,
  isLoading: false,
});

export const inValidParams = () => dispatch => {
  dispatch({
    type: actionTypes.FETCH_FAILED,
    isLoading: false,
  });
};

export const setSecondaryJourney = isSecondary => dispatch => {
  dispatch({
    type: actionTypes.SET_SECONDARY_JOURNEY,
    isSecondary,
  });
};

export const setContent = payload => 
({ type: actionTypes.FETCH_CONTENT_SUCCESS, payload });
